interface SummaryRowProps {
  label: string
  value?: string
}

export function SummaryRow({ label, value }: SummaryRowProps) {
  return (
    <div className="flex items-start justify-between gap-3 text-sm">
      <div className="text-gray-light-700 font-medium">{label}</div>
      <div className="text-gray-light-900 text-right font-semibold">{value ?? '-'}</div>
    </div>
  )
}
